
import { doc, getDoc, getFirestore } from 'firebase/firestore';
import { agentShopConverter, AGENT_SHOP } from '../entities/AgentShop';
import firebase from '../firebase/Firebase';


const store = getFirestore(firebase);

export const getAgentShop = async (id: string) => {
  const ref = doc(store, AGENT_SHOP, id).withConverter(agentShopConverter);
  return await getDoc(ref).then((snap) => {
    return snap.data();
  }).catch((error) => {
    console.warn(error);
    return null;
  });
};